import type { WorkflowRunStatus } from "@/types/workflowEngine";

export function formatRunStatus(status: WorkflowRunStatus): string {
  switch (status) {
    case "waiting_approval":
      return "Needs your decision";
    case "running":
      return "Running";
    case "pending":
      return "Starting";
    case "paused":
      return "Paused";
    case "waiting_chat":
      return "Waiting for chat";
    case "completed":
      return "Completed";
    case "failed":
      return "Failed";
    case "cancelled":
      return "Cancelled";
    default:
      return status;
  }
}

export function formatRunStatusSubtitle(
  status: WorkflowRunStatus,
  currentStepLabel?: string
): string | undefined {
  if (status === "waiting_approval") {
    return "Review the email below, then choose Keep or Move to trash.";
  }
  if (currentStepLabel) {
    return `Current step: ${currentStepLabel}`;
  }
  return undefined;
}
